import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  IconButton,
  Tooltip,
  TextField,
  Box
} from '@mui/material';
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Search as SearchIcon
} from '@mui/icons-material';

const RegistryTable = ({
  schema,
  data,
  totalCount,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  onEdit,
  onDelete,
  onSearch
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearch = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    if (onSearch) {
      onSearch(value);
    }
  };

  const getVisibleColumns = () => {
    return Object.entries(schema.properties)
      .filter(([_, field]) => field.visible_on_ui)
      .map(([fieldName, field]) => ({
        field: fieldName,
        headerName: field.name,
        type: field.type,
        searchable: field.searchable
      }));
  };

  const renderCell = (field, value) => {
    if (field.relationship) {
      const option = field.relationship.options?.find(opt => opt.value === value);
      return option ? option.label : value;
    }

    switch (field.type) {
      case 'boolean':
        return value ? 'Yes' : 'No';
      case 'date':
        return value ? new Date(value).toLocaleDateString() : '';
      case 'datetime':
        return value ? new Date(value).toLocaleString() : '';
      case 'time':
        return value ? new Date(value).toLocaleTimeString() : '';
      default:
        return value;
    }
  };

  const columns = getVisibleColumns();

  return (
    <Paper elevation={2}>
      <Box sx={{ p: 2, display: 'flex', alignItems: 'center' }}>
        <TextField
          size="small"
          placeholder="Cerca..."
          value={searchTerm}
          onChange={handleSearch}
          InputProps={{
            startAdornment: <SearchIcon sx={{ mr: 1, color: 'text.secondary' }} />
          }}
          sx={{ width: 300 }}
        />
      </Box>
      
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell key={column.field}>
                  {column.headerName}
                </TableCell>
              ))}
              <TableCell align="right">Azioni</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, index) => (
              <TableRow key={index}>
                {columns.map((column) => (
                  <TableCell key={column.field}>
                    {renderCell(column, row[column.field])}
                  </TableCell>
                ))}
                <TableCell align="right">
                  <Tooltip title="Modifica">
                    <IconButton
                      size="small"
                      onClick={() => onEdit(row)}
                    >
                      <EditIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Elimina">
                    <IconButton
                      size="small"
                      onClick={() => onDelete(row)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      
      <TablePagination
        component="div"
        count={totalCount}
        page={page}
        onPageChange={onPageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={onRowsPerPageChange}
        rowsPerPageOptions={[5, 10, 25, 50]}
        labelRowsPerPage="Righe per pagina:"
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} di ${count}`
        }
      />
    </Paper>
  );
};

export default RegistryTable; 